import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Wand2, ChevronRight, Sparkles } from "lucide-react";
import { TID } from "@/constants/testIds";
import { toast } from "sonner";

const STATUSES = ["Da valutare", "Approvata", "Programmata", "In corso", "Completata", "Non approvata"];

export default function ActionCenterPage() {
    const qc = useQueryClient();
    const q = useQuery({ queryKey: ["ai-actions"], queryFn: () => api.get("/ai-actions").then((r) => r.data) });
    const patch = useMutation({
        mutationFn: ({ id, ...p }) => api.patch(`/ai-actions/${id}`, p),
        onSuccess: () => qc.invalidateQueries({ queryKey: ["ai-actions"] }),
    });

    const items = q.data || [];

    return (
        <div className="space-y-6 pv-enter">
            <div>
                <div className="pv-eyebrow mb-2 flex items-center gap-1.5"><Sparkles size={11} strokeWidth={1.5} />Prime Vision AI</div>
                <h1 className="pv-serif text-4xl tracking-tight">AI Action Center</h1>
                <p className="text-[13.5px] text-textmuted mt-2 max-w-2xl">
                    Ogni consiglio generato dall'AI, ordinato per priorità e impatto. Approva, programma o trasforma in task con un click.
                </p>
            </div>

            <div className="space-y-2">
                {items.map((a) => (
                    <div key={a.id} data-testid={TID.actionRow(a.id)} className="pv-card pv-hover p-5">
                        <div className="flex items-start gap-4">
                            <div className="h-10 w-10 rounded-xl bg-primary/[0.08] text-primary flex items-center justify-center flex-shrink-0">
                                <Wand2 size={15} strokeWidth={1.5} />
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="flex items-center gap-2 flex-wrap mb-1">
                                    <span className="text-[10.5px] px-2 py-0.5 rounded-md bg-primary/[0.08] text-primary">{a.area}</span>
                                    <span className="text-[10.5px] px-2 py-0.5 rounded-md bg-textsubtle/10 text-textmuted">Priorità {a.priority}</span>
                                    <span className="text-[10.5px] px-2 py-0.5 rounded-md bg-warning/10 text-warning">Impatto {a.impact}</span>
                                </div>
                                <div className="text-[15px] font-medium leading-snug">{a.title}</div>
                                <div className="text-[12.5px] text-textmuted mt-1.5">{a.reason}</div>
                                <div className="text-[11.5px] text-textsubtle mt-1.5">
                                    <span className="pv-mono">{a.time_needed}</span> · {a.suggested_owner} · KPI: {a.kpi}
                                </div>
                            </div>
                            <div className="flex flex-col items-end gap-2">
                                <select
                                    value={a.status}
                                    onChange={(e) => patch.mutate({ id: a.id, status: e.target.value })}
                                    className="text-[12px] rounded-lg border border-border/[var(--border-opacity)] bg-surface px-2 py-1.5"
                                >
                                    {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                                </select>
                                <button
                                    onClick={() => { patch.mutate({ id: a.id, status: "Approvata" }); toast.success("Azione approvata."); }}
                                    className="text-[12px] flex items-center gap-1 text-primary hover:underline"
                                >
                                    Approva <ChevronRight size={12} strokeWidth={1.5} />
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
